
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 9.5a.5.5 0 01-.83.376L1.6 6.753a1 1 0 010-1.506l3.57-3.123A.5.5 0 016 2.5v1.512c3.274.154 5 1.855 5 4.988v1.207l-.854-.853C9.023 8.23 7.655 7.759 6 7.936V9.5zM5 3.602L2.26 6 5 8.398V7.5a.5.5 0 01.418-.493c1.707-.285 3.21 0 4.481.851C9.525 5.926 8.1 5 5.5 5a.5.5 0 01-.5-.5v-.898z","fill":"#797B86"}})])
          )
        }
      }
    